import { generateBFFUrl, FETCH_TIME_SLOTS } from '@/configs/apiEndPoints';
import { serviceRequestType } from '@/context/serviceRequestContext';
import axiosInstance from './axiosConfig';
import { getServiceType } from './serviceRequestSummary';

export const fetchTimeSlots = async (
  jobType: serviceRequestType,
  jobDate: string,
  hubCode: string,
  selectedProduct: any,
  profileState: any,
  assetId?: string,
  workOrderId?: string,
) => {
  const { address } = selectedProduct;
  const { address1 = '', address2 = '', latitude, longitude, city, state, postal_code } = address;
  const timeSlots = await axiosInstance
    .post(
      generateBFFUrl(FETCH_TIME_SLOTS),
      {
        customer: {
          location: {
            address_line1: address1,
            address_line2: address2,
            district: '',
            pincode: postal_code,
            city: city,
            state: state,
            country: '',
            latitude: latitude,
            longitude: longitude,
          },
        },
        job_type: getServiceType(jobType),
        job_date: jobDate,
        hub_code: hubCode,
        customer_asset: assetId,
        work_order_id: workOrderId,
      },
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
  return timeSlots;
};
